module.exports = __webpack_public_path__ + "img/glassthicknessplus-15.6630442c.svg";